import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { setLoginSize } from "@/utils/window";
import userInfoStore from "@/store/user.store";
import loginInfoStore from "@/store/login.store";
import http from "@/services/http";

interface IProps {
  visible: boolean;
  onClose: () => void;
}

// 修改密码成功弹窗
export default function PwdChangedModal({ visible, onClose }: IProps) {
  const navigate = useNavigate();

  // 跳转到登录页
  const handleConfirm = () => {
    // 清除用户信息和登录状态
    userInfoStore.getState().resetUser();
    loginInfoStore.getState().setHasLogin(false);
    http.clearToken();

    setLoginSize();
    navigate("/login", { replace: true });
    onClose();
  };

  if (!visible) return null;

  return createPortal(
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-9999 flex items-center justify-center">
      <div className="bg-white rd-3 w-80 h-31.5 flex flex-col items-center justify-center px-6">
        <div className="text-center mb-6">
          <div className="text-size-3.5 text-#191D26 lh-5.5">
            你已成功修改密码，请重新登录后继续使用
          </div>
        </div>

        <div className="flex items-end justify-end w-full">
          <button
            className="w-18.5 h-8 rd-2 bg-#4981F2 text-white text-size-3.5 cursor-pointer border-none outline-none hover:opacity-90"
            onClick={handleConfirm}
          >
            知道了
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
} 